import React from 'react';

import PlannerContainer from './PlannerContainer';
import { PlannerDetail } from './PlannerDetail';

const PlannerPage: React.FC = () => (
    <PlannerContainer.Provider>
        <PlannerDetail/>
    </PlannerContainer.Provider>
);
export default PlannerPage;
